import type { TaskStatus, Task } from '../lib/api'
import Column from './Column'

export const COLUMNS: { id: TaskStatus; label: string; accent: string }[] = [
  { id: 'todo', label: 'À faire', accent: '#64748B' },
  { id: 'in_progress', label: 'En cours', accent: '#C0851C' },
  { id: 'review', label: 'En revue', accent: '#7C3AED' },
  { id: 'done', label: 'Done', accent: '#2E7D52' },
]

interface BoardProps {
  tasks: Task[]
  draggedTaskId: number | null
  onDropTask: (status: TaskStatus, index: number) => void
  onDeleteTask: (id: number) => void
  onDragStartTask: (id: number) => void
}

export default function Board({
  tasks,
  draggedTaskId,
  onDropTask,
  onDeleteTask,
  onDragStartTask,
}: BoardProps) {
  return (
    <div className="flex gap-4 overflow-x-auto board-scroll pb-4 flex-1">
      {COLUMNS.map((col) => {
        const colTasks = tasks
          .filter((t) => t.status === col.id)
          .sort((a, b) => a.position - b.position)
        return (
          <Column
            key={col.id}
            status={col.id}
            label={col.label}
            accent={col.accent}
            tasks={colTasks}
            draggedTaskId={draggedTaskId}
            onDropTask={onDropTask}
            onDeleteTask={onDeleteTask}
            onDragStartTask={onDragStartTask}
          />
        )
      })}
    </div>
  )
}
